module.exports = {
  en: {
    message: {
      welcome: 'Welcome',
      settings: 'Settings'
    }
  },
  it: {
    message: {
      welcome: 'Benvenuto',
      settings: 'Impostazioni'
    }
  },
  de: {
    message: {
      welcome: 'Willkommen',
      settings: 'Einstellungen'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale.js